import { moduleNames } from 'pages/Stores/components/modules';
import { createArtistsConfig } from './ArtistsConfig';
import { buildCustomArtistPayload, isCustomArtist } from './utils';

const defaultValues = {
  customItems: [],
  selectedItems: [],
};

export const createArtistsModule = (useAvailableItems) => ({
  moduleName: moduleNames.ARTISTS,
  nameTranslationPath: 'artists.title',
  descriptionTranslationPath: 'artists.moduleDescription',
  iconClassName: 'bi bi-people',
  defaultValues,
  isValid: (values) => values.selectedItems?.length > 0,
  buildPayload: async (values) =>
    Promise.all(
      values.selectedItems.map((item) =>
        isCustomArtist(item) ? buildCustomArtistPayload(item) : item,
      ),
    ),
  parseApiData: (module) => {
    const participants =
      module.participants ||
      module.participant_uids ||
      module.participants_module?.participants ||
      module.participants_module?.participant_uids ||
      [];
    const selectedItems = Array.isArray(participants) ? participants : [participants];
    return {
      ...defaultValues,
      customItems: selectedItems.filter(isCustomArtist),
      selectedItems,
    };
  },
  ConfigComponent: createArtistsConfig(useAvailableItems),
});
